import { Map, useMap } from '@vis.gl/react-google-maps';
import React, { useEffect } from 'react';
import { Coordinates } from '../../types/address';

interface AddressSelectionMapProps {
    coordinates: Coordinates;
    setCoordinates: (coords: Coordinates) => void;
}

const FixedCenterMarker = () => (
    <div
        style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -100%)',
            zIndex: 1,
            pointerEvents: 'none',
        }}
    >
        <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
            <path
                d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5 14.5 7.62 14.5 9 13.38 11.5 12 11.5z"
                fill="#000000"
            />
        </svg>
    </div>
);

const AddressSelectionMap: React.FC<AddressSelectionMapProps> = ({ coordinates, setCoordinates }) => {

    const map = useMap();

    useEffect(() => {
        if(map){
            map.setCenter({lat: coordinates.latitude, lng: coordinates.longitude});
        }
    }, [coordinates])

    return (
        <div style={{ position: 'relative' }}>
            <Map
                style={{ width: '100%', height: 'calc(90vh - 200px)', borderRadius: '1rem' }}
                defaultCenter={{ lat: coordinates.latitude, lng: coordinates.longitude }}
                defaultZoom={18}
                gestureHandling="greedy"
                disableDefaultUI={true}
                onIdle={() => {
                    const center = map?.getCenter();
                    const lat = center?.lat();
                    const lng = center?.lng();

                    if (
                        !center ||
                        (!lat && !lng) ||
                        (lat === coordinates.latitude && lng === coordinates.longitude)
                    ) return;

                    setCoordinates({ latitude: lat!, longitude: lng! });
                }}
            />
            <FixedCenterMarker />
        </div>
    );
};

export default AddressSelectionMap;